import { render, staticRenderFns } from "./choiceVipCard.vue?vue&type=template&id=501822f0&scoped=true&"
import script from "./choiceVipCard.vue?vue&type=script&lang=js&"
export * from "./choiceVipCard.vue?vue&type=script&lang=js&"
import style0 from "./choiceVipCard.vue?vue&type=style&index=0&id=501822f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501822f0",
  null
  
)

export default component.exports